interface TransitionOptions {
  duration?: number;
  easing?: string;
  delay?: number;
}

// 动画时间配置
export const transitions = {
  durations: {
    shortest: 150,
    shorter: 200,
    short: 250,
    standard: 300,
    // 用于复杂的UI过渡，如模态框、遮罩、展开面板等
    complex: 375,
    // 用于遮罩层相关的过渡，如模态框、背景遮罩等
    overlay: 500,
    // 保留 Material-UI 的标准时间
    enteringScreen: 225,
    leavingScreen: 195,
  },
  easings: {
    // 标准缓动函数
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)',
    // 自定义缓动函数
    emphasized: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
  },
  // 创建过渡动画
  create: (props = ['all'], options: TransitionOptions = {}) => {
    const { duration = transitions.durations.standard, easing = transitions.easings.easeInOut, delay = 0 } = options;

    return props.map((prop) => `${prop} ${duration}ms ${easing}${delay ? ` ${delay}ms` : ''}`).join(',');
  },
};

export default transitions;
